export enum TooltipType {
  Available = 'available',
  NegativeAvailable = 'negativeAvailable'
}
